import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router"
import z from "zod"
import { requirePermission } from "@/lib/require-permission"
import { DeleteDocumentsDialog } from "../../-components/delete-documents-dialog"
import { useDocumentsSelectionContext } from "../route"

const searchSchema = z.object({
  ids: z.preprocess(
    (value) =>
      Array.isArray(value) ? value : value === undefined ? undefined : [value],
    z.array(z.string().uuid()).catch([]),
  ),
})

export const Route = createFileRoute("/_layout/documents/_list/delete/bulk")({
  component: DeleteDocumentsBulkModal,
  validateSearch: (search) => searchSchema.parse(search),
  beforeLoad: async ({ context: { queryClient }, search }) => {
    await requirePermission(queryClient, "document:delete", "/")
    if (search.ids.length === 0) {
      throw redirect({ to: "/documents", search: true })
    }
  },
})

function DeleteDocumentsBulkModal(): React.ReactElement {
  const { ids } = Route.useSearch()
  const navigate = useNavigate()
  const { clearDocumentSelection } = useDocumentsSelectionContext()

  return (
    <DeleteDocumentsDialog
      documentIds={ids}
      onClose={() => navigate({ to: "/documents", search: true })}
      onDeleted={clearDocumentSelection}
    />
  )
}
